'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module2Res1 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module2Res1, _Component);

  function Module2Res1() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module2Res1);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module2Res1.__proto__ || (0, _getPrototypeOf2.default)(Module2Res1)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currPage: 0,
      title: 'Making mealtimes positive'
    }, _this.handleClickNext = function () {
      var obj = _this.state;
      obj.currPage = _this.state.currPage + 1;
      _this.setState(obj);
    }, _this.handleClickPrev = function () {
      var obj = _this.state;
      obj.currPage = _this.state.currPage - 1;
      _this.setState(obj);
    }, _this.handleOnClick = function (item, event) {
      event.preventDefault();
      console.log(event);
      console.log('CLICKED ' + item);
      var obj = _this.state;
      obj.currPage = item;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /**
   *  User clicks on Next
   *  Increments the Page number and changes panel
   */


  /**
   *  User clicks on Previous
   *  Decrements the Page number and changes panel
   */


  /*
   * Quick link at the top to change the current page
   * to the selected page
   */


  (0, _createClass3.default)(Module2Res1, [{
    key: 'render',
    value: function render() {
      var styles = require('../Resources.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 12, sm: 12, xs: 12 },
          _react2.default.createElement(
            'div',
            { className: styles.activityPanel },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              _react2.default.createElement(
                'h3',
                null,
                'Module 2'
              ),
              _react2.default.createElement(
                'h2',
                null,
                this.state.title
              )
            ),
            _react2.default.createElement(
              'h3',
              null,
              'Try to eat meals together as a family'
            ),
            _react2.default.createElement(
              'p',
              null,
              'We know this may not always be possible, but it is important. Children are more likely to taste new foods or eat their meal when they see other family members eating them too.'
            ),
            _react2.default.createElement(
              'h3',
              null,
              'Try to maintain a positive, relaxed atmosphere at meal times'
            ),
            _react2.default.createElement(
              'p',
              null,
              'This can be difficult. If you can, try to use gentle and positive language.'
            ),
            _react2.default.createElement(
              'h3',
              null,
              'Try to eat at the table with electronic devices (tv, tablets) switched off'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Eating at a table, rather than a couch, will help to create a positive environment where everyone can talk about their day. Without the distraction of the TV, children are more likely to focus on their food. This helps them to become aware of their hunger and fullness cues. Children are also more likely to focus on any praise they receive for trying new foods or a previously disliked food. Praise and positive language is important in motivating children to taste these foods again.'
            ),
            _react2.default.createElement(
              'h3',
              null,
              'Try to maintain regular meal and snack routines'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Regular meal and snack times provide children with the confidence that food will be available throughout the day. This helps children to enjoy other activities and not worry about food. Encouraging kids to have snacks while sitting down rather than running or playing also establishes healthy habits at snack times. Eg. Even at a park, try to encourage kids to sit down and eat their snack before playing again.'
            ),
            _react2.default.createElement('div', { className: styles.spacer40 })
          )
        )
      );
    }
  }]);
  return Module2Res1;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module2Res1;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/2/Res1.js
// module id = 1236
// module chunks = 0